import { PageLayoutContentMainAreaAriaRole } from '@ms/yammer-web-core-ui/dist/components/PageLayout';
import { createContext } from 'react';

export interface AppContextOptions {
  readonly mainAreaAriaRole: PageLayoutContentMainAreaAriaRole;
  readonly enableCollapsiblePanelNav: boolean;
  readonly enableCommunityDiscoveryV2: boolean;
  readonly fullScreenModalDialogMarginTop?: number;
  readonly messagePanelMarginTop?: number;
  readonly disableVideoPlayer: boolean;
}

export const defaultOptions: AppContextOptions = {
  mainAreaAriaRole: PageLayoutContentMainAreaAriaRole.Main,
  enableCollapsiblePanelNav: false,
  enableCommunityDiscoveryV2: false,
  fullScreenModalDialogMarginTop: undefined,
  messagePanelMarginTop: undefined,
  disableVideoPlayer: false,
};

export default createContext(defaultOptions);
